const ATTENDANCE_TIME_ZONE = 'Asia/Tashkent';

const isClockValue = (value: string) => /^\d{2}:\d{2}(:\d{2})?$/.test(value);

export const formatAttendanceTime = (
  value: string | Date | null | undefined,
  locale = 'uz-UZ',
): string | null => {
  if (!value) {
    return null;
  }

  if (typeof value === 'string' && isClockValue(value)) {
    return value.slice(0, 5);
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: ATTENDANCE_TIME_ZONE,
  }).format(date);
};

export const formatAttendanceDate = (
  value: string | Date | null | undefined,
  locale = 'uz-UZ',
): string | null => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: ATTENDANCE_TIME_ZONE,
  }).format(date);
};